export default "__VITE_ASSET__0xVTUC3G__"